import {
  adminV2ExactIdentitySchema,
  adminV2StableIdentitySchema,
} from '@/admin-v2/foundation/admin-v2-identity';
import {
  ADMIN_V2_WORKSPACE_TOOL_CATALOG_CUSTOM_ICON_MAX_BYTES,
  ADMIN_V2_WORKSPACE_TOOL_CATALOG_CUSTOM_ICON_MIME_TYPE,
} from '@/admin-v2/site-experience/workspace-tool-catalog-icon';
import { z } from 'zod';

export const ADMIN_V2_TOOL_CUSTOM_ICON_MIME_TYPE =
  ADMIN_V2_WORKSPACE_TOOL_CATALOG_CUSTOM_ICON_MIME_TYPE;
export const ADMIN_V2_TOOL_CUSTOM_ICON_MAX_BYTES =
  ADMIN_V2_WORKSPACE_TOOL_CATALOG_CUSTOM_ICON_MAX_BYTES;
export const ADMIN_V2_TOOL_CUSTOM_ICON_STORAGE_PREFIX = 'cms/v2/tool-icons/';

export const adminV2ToolCustomIconAssetIdSchema = adminV2StableIdentitySchema;

const toolCustomIconStorageKeyPattern = new RegExp(
  `^${escapeRegExp(
    ADMIN_V2_TOOL_CUSTOM_ICON_STORAGE_PREFIX
  )}[a-zA-Z0-9][a-zA-Z0-9_-]{0,80}\\.svg$`
);

export const adminV2ToolCustomIconStorageKeySchema = z
  .string()
  .regex(
    toolCustomIconStorageKeyPattern,
    'Tool custom icon storage key must be a server-owned SVG asset key.'
  );

export const adminV2ToolCustomIconReferenceSchema = z
  .object({
    iconSource: z.literal('custom'),
    assetId: adminV2ToolCustomIconAssetIdSchema,
    storageKey: adminV2ToolCustomIconStorageKeySchema,
    mimeType: z.literal(ADMIN_V2_TOOL_CUSTOM_ICON_MIME_TYPE),
  })
  .strict()
  .superRefine((reference, context) => {
    const expectedStorageKey = `${ADMIN_V2_TOOL_CUSTOM_ICON_STORAGE_PREFIX}${reference.assetId}.svg`;
    if (reference.storageKey !== expectedStorageKey) {
      context.addIssue({
        code: 'custom',
        message: 'Tool custom icon storage key must match its asset id.',
        path: ['storageKey'],
      });
    }
  });

export const adminV2ToolIconSchema = z.union([
  adminV2ExactIdentitySchema,
  adminV2ToolCustomIconReferenceSchema,
]);

export type AdminV2ToolCustomIconReference = z.infer<
  typeof adminV2ToolCustomIconReferenceSchema
>;

export type AdminV2ToolIcon = z.infer<typeof adminV2ToolIconSchema>;

export type AdminV2ToolDisplayIcon =
  | AdminV2ToolIcon
  | (AdminV2ToolCustomIconReference & { url: string })
  | { iconSource: 'custom'; url: string };

export type AdminV2ToolCustomIconUploadResponse = {
  icon: AdminV2ToolCustomIconReference;
  url: string;
};

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
